// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3WWpg","label":"styles_label__3ZqyF"};